import { LitElement, html, svg } from 'lit';

export class IconLandscape56 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" fill="none" viewBox="0 0 56 56"><title>Sol og fjell</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM53 50 38.648 26.58A3.533 3.533 0 0 0 35.749 25a3.52 3.52 0 0 0-2.933 1.514l-9.393 13.464-5.821-4.685a3.525 3.525 0 0 0-2.749-.736 3.52 3.52 0 0 0-2.396 1.538L3 50"></path></svg>`; }
}
if (!customElements.get('f-icon-landscape56', IconLandscape56)) {
  customElements.define('f-icon-landscape56', IconLandscape56);
}